module.exports = __webpack_public_path__ + "img/toggle-chevron-down-icon.702193b4.svg";